import { useCallback, useState } from "react";
import { CoachTriggerType } from "../types";

import { Button } from "V2.0/common/button";

import TriggerCoachConditional from "./TriggerCoachConditional";
import TriggerCoachLLMBased from "./TriggerCoachLLMBased";
import TriggerCoachTypeSelect from "./TriggerCoachTypeSelect";
import MinConversationTurn from "./MinConversationTurn";

import { showErrorToast } from "V2.0/utils";
import { message } from "antd";

export default AssistantCoachTrigger;

const AssistantCoachTriggerTypeRegistry = {
  [CoachTriggerType.EveryTurn]: () => {},
  [CoachTriggerType.Conditional]: TriggerCoachConditional,
  [CoachTriggerType.LLMBased]: TriggerCoachLLMBased,
};

function getDefaultCoachTriggerState(coachTrigger) {
  return {
    triggerType: coachTrigger?.triggerType ?? CoachTriggerType.Conditional,
    triggerConditions: coachTrigger?.triggerConditions ?? [],
    triggerPrompt: coachTrigger?.triggerPrompt ?? "",
    minConversationTurns: coachTrigger?.minConversationTurns ?? 0,
  };
}

function AssistantCoachTrigger(props) {
  const { assistantCoach, onUpdateAssistant, isUnlocked } = props;

  const [coachTriggerState, setCoachTriggerState] = useState(() =>
    getDefaultCoachTriggerState(assistantCoach?.triggerSettings),
  );
  const [loading, setLoading] = useState<boolean>(false);

  const handleSave = useCallback(async (data) => {
    const payload = {
      triggerSettings: {
        ...data,
        triggerConditions: Array.isArray(data.triggerConditions)
          ? data.triggerConditions
          : data.triggerConditions.split(","),
      },
    };

    const lifecycleCbs = {
      init() {
        setLoading(true);
        message.loading("Updading Trigger Settings");
      },
      success() {
        setLoading(false);
        message.destroy();
        message.success("Trigger Settigns Updated");
      },
      error(e) {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to update Trigger Settings");
      },
    };

    onUpdateAssistant(payload, lifecycleCbs);
  }, []);

  const TriggerTypeComponent =
    AssistantCoachTriggerTypeRegistry[coachTriggerState.triggerType];

  return (
    <div className="w-2/4 min-w-[500px] p-4 h-full">
      <div className="border rounded-lg">
        <div className="px-6 py-3 bg-gray-50 rounded-t-lg">
          <p className="text-md font-semibold">Triggers</p>
        </div>

        <div className="p-8 space-y-4 flex flex-col">
          <div>
            <TriggerCoachTypeSelect
              coachTriggerState={coachTriggerState}
              setCoachTriggerState={setCoachTriggerState}
              isUnlocked={isUnlocked}
            />
          </div>
          <MinConversationTurn
            coachTriggerState={coachTriggerState}
            setCoachTriggerState={setCoachTriggerState}
            isUnlocked={isUnlocked}
          />
          <TriggerTypeComponent
            coachTriggerState={coachTriggerState}
            setCoachTriggerState={setCoachTriggerState}
            isUnlocked={isUnlocked}
          />
        </div>
        {isUnlocked && (
          <div className="bg-gray-50 rounded-b-lg text-right px-6 py-3">
            <Button
              loading={loading}
              disabled={loading}
              onClick={() => handleSave(coachTriggerState)}
            >
              Save
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
